import SnippetsGrid from '../../components/snippetsGrid';
import { Link } from "react-router-dom";
import {linkStyle} from "../../components/helpersStyles";
//import { IconButton, Tooltip } from '@mui/material';
//import { Icon as Iconify } from '@iconify/react';
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../../commonComponents/styledTexts';
import { useEffect } from "react";
import { InfoToolTip } from "../../commonComponents/generalComponents"

import introJs from 'intro.js';
import 'intro.js/introjs.css'
import '../../ccIntroJs/ccIntroJsStyles.css'
import { CcIntroJsStyledText } from '../../ccIntroJs/ccIntroJsStyledText';
import { showIntroJsTourForCurrentPage } from '../../ccIntroJs/ccIntroJsDisplayLogic';

export default function ProductHomeConditionsManager() {
    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        showIntroJsTourForCurrentPage(introJs)
    }, [])

    return <div>
            <CcTitle>
                Conditions Manager
            </CcTitle>

            <div className=" text-ccColorDarkTeal">Create engaging animated GIFs that drive clicks to a branded landing page, where recipients can ‘scratch off’ to reveal exclusive offers—bringing gamification, fun, and interactivity to their inbox.</div>

            <div className="w-fit" data-intro={CcIntroJsStyledText({title: 'Start here', mainText: 'This launches a wizard that creates your <span class="font-semibold">element</span><div class="mt-2">An <span class="font-semibold">element</span> is the html tag to copy into your email</div>'})}>
                <Link to={`/workflow/27`} style={linkStyle}>
                    <CcCreateNewSnippet className="mt-4" >Create Conditions Manager</CcCreateNewSnippet>
                </Link>
            </div>

            <div className="w-fit" data-intro={CcIntroJsStyledText({title: 'Elements section', mainText: '<div>List of all the Elements you created</div><div>You can edit an element even if you have already put it in a live email</div>'})}>
                <CcSubSectionTitle className=" mt-6">Latest Conditions Manager Elements</CcSubSectionTitle>
            </div>
            <SnippetsGrid productTypeId={27}
                 //editCall={(id, typeId) => editSnippet(id, typeId)}
             />

    </div>
}